module.exports = "/_next/static/images/TestimonialImage@2x-5b9ef6126c40687457d7060a4473e6a2.webp";